import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertTriangle, LogOut } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

interface EmpresaDesativadaProps {
  empresaNome?: string;
}

export default function EmpresaDesativada({ empresaNome = "sua empresa" }: EmpresaDesativadaProps) {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth/login");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <Card className="w-full max-w-md border-destructive">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Acesso Bloqueado</CardTitle>
          <CardDescription className="mt-2">
            A conta da empresa foi desativada
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert variant="destructive">
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>Atenção</AlertTitle>
            <AlertDescription>
              O acesso à plataforma foi bloqueado porque a empresa <strong>{empresaNome}</strong> está desativada.
              Entre em contato com o suporte para reativar sua conta.
            </AlertDescription>
          </Alert>

          <div className="space-y-2 text-sm text-muted-foreground">
            <p>Quando uma empresa é desativada:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Todos os usuários perdem acesso à plataforma</li>
              <li>Nenhuma funcionalidade está disponível</li>
              <li>Os dados permanecem armazenados</li>
            </ul>
          </div>

          <Button
            onClick={handleSignOut}
            variant="outline"
            className="w-full"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Fazer Logout
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

